import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import moment from 'moment';
import Loader from '../../components/loader';
import Sidemenu from '../../components/sidemenu';
import Header from '../../components/header';
// import Footer from '../../components/footer';
import * as Styled from './styled';

import { getRequest } from '../addContest/actions';

class ContestDetails extends Component {
  constructor (props) {
    super(props)
    this.state = {
      seconds: 0,
    }
    this.timer = 0;
  }

  UNSAFE_componentWillMount() {
    if (window && window.location && window.location.pathname) {
      const pathArr = window.location.pathname.split('/');
      if (typeof pathArr[3] !== 'undefined' && pathArr[3] !== '') {
        this.props.getRequest(pathArr[3]);
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.timer === 0
    && this.state.seconds === 0
    && nextProps.contestDetail
    && nextProps.contestDetail.getContestLoading === false
    && nextProps.contestDetail.getContest
    && nextProps.contestDetail.getContest.data
    && nextProps.contestDetail.getContest.data.contestData
    && nextProps.contestDetail.getContest.data.contestData[0]
    && nextProps.contestDetail.getContest.data.contestData[0].contest_start_date
    && nextProps.contestDetail.getContest.data.contestData[0].contest_end_date) {
      const data = nextProps.contestDetail.getContest.data.contestData[0];
      const seconds = moment(data.contest_end_date).diff(moment(), 'seconds');

      if (seconds > 0) {
        const time = this.secondsToTime(seconds)
        this.setState({ seconds, time }, () => this.startTimer());
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  secondsToTime = (secs) => {
    let time = '';
    if (typeof secs !== 'undefined' && secs !== null) {
      let days = Math.floor(secs / (3600*24));
      let hours = Math.floor(secs % (3600*24) / 3600);
      let minutes = Math.floor(secs % 3600 / 60);
      let seconds = Math.floor(secs % 60);

      const obj = {
        "d": `${days < 10 ? '0' : ''}${days}D : `,
        "h": `${hours < 10 ? '0' : ''}${hours}H : `,
        "m": `${minutes < 10 ? '0' : ''}${minutes}M : `,
        "s": `${seconds < 10 ? '0' : ''}${seconds}S`,
      };
      time = `${days > 0 ? obj.d : ''}${hours > 0 ? obj.h : ''}${obj.m}${obj.s}`;
    }
    return time;
  }

  startTimer = () => {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.timer = setInterval(() => {
        let seconds = this.state.seconds;
        seconds -= 1;
        this.setState({ time: this.secondsToTime(seconds), seconds });
      }, 1000);
    }
  }

  render () {
    const { getContest, getContestLoading } = this.props.contestDetail;
    let data = {};

    if (getContestLoading === false
    && getContest
    && getContest.data
    && getContest.data.contestData
    && getContest.data.contestData[0]) {
      data = getContest.data.contestData[0];
    }

    return (
      <Styled.MainDiv>
        <Loader show={getContestLoading} heading="Getting Details" />
        <Sidemenu collapsed={this.state.sideMenuCollapsed} />

        <Styled.ColumnDiv>
          <Header />

          { isEmpty(data) === false ?
            <Styled.ContentDiv>

              <Styled.LeftDiv>
                <Styled.TopDiv>
                  <Styled.CompanyWrapDiv>
                    <img src={data.company_logo} alt="" />
                    <Styled.CompanyDiv>
                      <div>{data.job_title}</div>
                      <div>{data.company_name}</div>
                      <div>{`Posted  on ${moment(data.created_at).format("DD MMM YYYY")}`}</div>
                    </Styled.CompanyDiv>
                  </Styled.CompanyWrapDiv>

                  <Styled.TimeDiv>
                    <img src="/clock-icon.svg" alt="" />
                    { this.state.seconds > 0 ?
                      <Styled.TimeWrapDiv>
                        <Styled.TimeTextDiv>Job is ending on</Styled.TimeTextDiv>
                        <Styled.RemTimeDiv>{this.state.time}</Styled.RemTimeDiv>
                      </Styled.TimeWrapDiv>
                    :
                      <Styled.TimeWrapDiv>
                        <Styled.TimeTextDiv>Job is ended</Styled.TimeTextDiv>
                        <Styled.RemTimeDiv>00H : 00M : 00S</Styled.RemTimeDiv>
                      </Styled.TimeWrapDiv>
                    }
                  </Styled.TimeDiv>
                </Styled.TopDiv>

                <Styled.InfoWrapDiv>
                  { data.company_website ?
                    <Styled.InfoDiv>
                      <div>WEBSITE</div>
                      <div>{data.company_website}</div>
                    </Styled.InfoDiv>
                  : <></>
                  }

                  <Styled.InfoDiv>
                    <div>LOCATION</div>
                    <div>{data.job_location_list.length === 1 ? data.job_location_list[0] : data.job_location_list.join(', ')}</div>
                  </Styled.InfoDiv>

                  <Styled.InfoDiv>
                    <div>JOB TYPE</div>
                    <div>{data.job_type}</div>
                  </Styled.InfoDiv>

                  <Styled.InfoDiv>
                    <div>Maximum Compensation</div>
                    <div>{`Rs. ${data.min_ctc}-${data.max_ctc} LPA`}</div>
                  </Styled.InfoDiv>

                  <Styled.InfoDiv>
                    <div>Expereince</div>
                    <div>{`${data.min_experience}-${data.max_experience} Years`}</div>
                  </Styled.InfoDiv>

                  <Styled.InfoDiv>
                    <div>No. of Positions</div>
                    <div>{data.openings}</div>
                  </Styled.InfoDiv>

                  <Styled.InfoDiv>
                    <div>Joining Time</div>
                    <div>{data.job_start_date}</div>
                  </Styled.InfoDiv>

                  <Styled.InfoDiv>
                    <div>Skills</div>
                    <div>{data.skills_list.length === 1 ? data.skills_list[0] : data.skills_list.join(', ')}</div>
                  </Styled.InfoDiv>
                </Styled.InfoWrapDiv>

                <Styled.DetailsWrapDiv>
                  <Styled.HeadingDiv>Job Description</Styled.HeadingDiv>
                  <Styled.TextDiv dangerouslySetInnerHTML={{__html: data.job_description}}></Styled.TextDiv>
                </Styled.DetailsWrapDiv>
              </Styled.LeftDiv>

              <Styled.RightDiv>
                <Styled.AssessmentWrapDiv>
                  <Styled.AssessmentHeadDiv>Assesement Creteria</Styled.AssessmentHeadDiv>
                  <Styled.AssessmentDiv>
                    <div>No. of questions</div>
                    <div>{data.total_questions}</div>
                  </Styled.AssessmentDiv>
                  <Styled.AssessmentDiv>
                    <div>Duration</div>
                    <div>{`${data.test_duration} Minutes`}</div>
                  </Styled.AssessmentDiv>
                  <Styled.AssessmentDiv>
                    <div>Total Marks</div>
                    <div>{data.total_marks}</div>
                  </Styled.AssessmentDiv>
                  <Styled.AssessmentDiv>
                    <div>Questions</div>
                    <div>{data.test_name}</div>
                  </Styled.AssessmentDiv>
                </Styled.AssessmentWrapDiv>

              </Styled.RightDiv>
            </Styled.ContentDiv>
          : <></>
          }
          {/* <Footer /> */}
        </Styled.ColumnDiv>
      </Styled.MainDiv>
    )
  }
}

const mapStateToProps = state => ({
  contest: state.contest,
  contestDetail: state.addContest,
})

const mapDispatchToProps = {
  getRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(ContestDetails)
